import { useState } from "react";
import PrivateApi from "../../services/PrivateApiService";
import { Button, Card, CardBody, Col, Container, Row } from "react-bootstrap";
import AnimatedSprite from "../../components/shared/AnimatedSprite";
import { useQuery } from "react-query";
import SplashPage from "../SplashPage";
import ErrorPage from "../ErrorPage";
import NotificationModal from "../../components/shared/notification/NotificationModal";
import DashCountCard from "../../components/dashboard/DashCountCard";
import DashTicketsList from "../../components/dashboard/DashTicketsList";
import DashElvsCard from "../../components/dashboard/DashElvsCard";
import { useNavigate } from "react-router-dom";


const PrivateDashboardPage = () => {

    // initial variables
    const API = new PrivateApi(); 
    const navigate = useNavigate();
    const [animation, setAnimation] = useState(false);
    

    // fetch data
    const {data, error, isLoading} = useQuery('clientDashboard', API.client_dashboard, {staleTime: Infinity});

    // if loading or error
    if (isLoading) return <SplashPage />;
    if (error) return <ErrorPage />;

    // random animation popup
    if (Math.random() < 0.05) {
        setAnimation(true);
    }

    // gui
    return (
        <Container className="text-start">
            <Row className="align-items-center">
                <Col xs="6">
                    <h1>Dashboard</h1>
                </Col>
                <Col xs="6" className="text-end">
                    <p className="text-muted">{new Date().toLocaleDateString('DE-de')}</p>
                </Col>
            </Row>

            {animation === true?
                <AnimatedSprite show={animation} setShow={setAnimation} />
                :null
            }

            <Row className="mt-3">
                <Col md="12" xl="8">
                    <Row>
                        <Col md="6" xl="6">
                            <DashCountCard 
                                schema={"warning"} 
                                cardTitle={"News"} 
                                count={data.data.notifications.length}
                                cardLink={"/dashboard/news/"}
                            />
                        </Col>

                        <Col md="6" xl="6">
                            <DashCountCard 
                                schema={"violet"} 
                                cardTitle={"Dokumente"} 
                                count={data.data.download_count} 
                                cardLink={"/dashboard/dokumente"}
                            />
                        </Col>
                    </Row>
                    <Row className="mt-3 mb-3">
                        <Col xl="12">
                            <DashElvsCard elvs={data.data.elvs} />
                        </Col>
                    </Row>
                </Col>

                <Col xl="4">
                    <Row>
                        <Col xs="12" md="5" xl="12" className="mb-3">
                            <Card style={{borderRadius: 15}} className="h-100 shadow-lg">
                                <CardBody>
                                    <div className="d-flex flex-column gap-2 h-100 justify-content-center">
                                        <Button 
                                            onClick={() => navigate("/dashboard/anlagen/anmelden/")} 
                                            style={{borderRadius: 15}} 
                                            variant="energo"
                                            className={data.data.anlagen_count === 0 ? "pulse":null}
                                        >
                                            Neue Anlage hinzufügen
                                        </Button>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xs="12" md="7" xl="12">
                            <DashTicketsList tickets={data.data.tickets} />
                        </Col>
                    </Row>
                </Col>

            </Row>          

            {data.data.notifications && data.data.notifications.length > 0 ?
                <NotificationModal notifications={data.data.notifications} />
            : null}
        </Container>
    )
}

export default PrivateDashboardPage;